import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { rememberPostLoginRedirect } from '../utils/postLoginRedirect';
import { useAuth } from '../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!user) {
    // Come back here after sign-in (e.g. a shared-chat link).
    rememberPostLoginRedirect(location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user.role !== 'Admin') {
    return <Navigate to="/chat" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;

